export default __webpack_public_path__ + "static/media/jumbo.25570407.svg";